import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  // Préférence : token customer (Mon Espace) puis admin (back-office)
  const token = localStorage.getItem("msc_customer_token") || localStorage.getItem("kap_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  async (e) => {
    if (e?.response?.status === 401 && window.location.pathname.startsWith("/admin") && !window.location.pathname.includes("/login")) {
      localStorage.removeItem("kap_token");
      localStorage.removeItem("kap_user");
      window.location.href = "/admin/login";
    }
    // Exponential-backoff retry for 429 (preview ingress anti-bot throttling)
    const cfg = e?.config;
    const status = e?.response?.status;
    if (status === 429 && cfg && !cfg.__noRetry) {
      cfg.__retryCount = (cfg.__retryCount || 0) + 1;
      if (cfg.__retryCount <= 3) {
        const delay = 400 * Math.pow(2, cfg.__retryCount - 1) + Math.random() * 200;
        await new Promise((res) => setTimeout(res, delay));
        return api(cfg);
      }
    }
    return Promise.reject(e);
  }
);

// Analytics tracking helper
export const track = async (event, extra = {}) => {
  try {
    await api.post("/track", {
      event,
      path: window.location.pathname,
      referrer: document.referrer || "",
      user_agent: navigator.userAgent,
      ...extra,
    });
  } catch (e) { /* swallow */ }
};
